import React, { Component } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

class PageItemCoupons extends Component {
    nextPage = () => {
        const { page, pages } = this.props.pagination;
        if (page < pages) this.props.setPage(page + 1);
    }

    previousPage = () => {
        const { page } = this.props.pagination;
        if (page > 1) this.props.setPage(page - 1);
    }

    handleClickPage = (val) => {
        this.props.setPage(val);
    }

    render() {
        const {pagination} = this.props;
        const {page, pages, total} = pagination;
        const listPage = [];
        
        for (let i = page - 2; i <= page + 2; i++) {
            if (i > 0 && i <= pages) listPage.push(i);
        }

        return (
            <div className="PageItemCoupon">
                <span>{total > 1 ? total + ' Results' : total + ' Result'}</span>
                <Pagination aria-label="Page navigation example">
                    <PaginationItem>
                        <PaginationLink previous onClick={this.previousPage} />
                    </PaginationItem>
                    {
                        listPage.map((page_item, index) => {
                            return (
                                <PaginationItem key={index} active={page_item === pagination.page}>
                                    <PaginationLink onClick={() => this.handleClickPage(page_item)}>
                                        {page_item}
                                    </PaginationLink>
                                </PaginationItem>
                            );
                        })
                    }
                    <PaginationItem>
                        <PaginationLink next onClick={this.nextPage} />
                    </PaginationItem>
                </Pagination>
            </div>
        );
    }
}

export default PageItemCoupons;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/components/PageItemCoupons.js